import docSign from "../../assets/png/docuSign.png";
import studioBinder from "../../assets/png/studioBinder.png";
import docuSignGif from "../../assets/gifs/intigration/docuSign.gif";
import studioBinderGif from "../../assets/gifs/intigration/studioBinder.gif";

export const intigrationData = [
  {
    title: "DocuSign",
    icon: docSign,
    gif: docuSignGif,
    description: [
      "DocuSign is a cloud-based electronic signature and digital transaction management platform that enables users to sign, send, and manage agreements and documents electronically.",
      "It provides a secure and legally binding way to handle signature and approval processes, reducing the time and costs associated with paper-based transactions.",
      "DocuSign is widely used in industries such as real estate, finance, and healthcare to streamline contract and document processes.",
    ],
  },
  {
    title: "Studiobinder",
    icon: studioBinder,
    gif: studioBinderGif,
    description: [
      "StudioBinder is a cloud-based project management platform specifically designed for the film and video production industry.",
      "It provides tools for organising and tracking pre-production, production, and post-production tasks, including scheduling, budgeting, shot lists, storyboarding, and call sheets.",
      "StudioBinder also offers collaboration tools that allow teams to communicate, share files, and work together in real-time.",
      "The platform is designed to help production teams streamline their workflow, increase efficiency, and reduce the time and effort required to manage the various aspects of a film or video production project.",
    ],
  },
];
